import { c as _c } from "react/compiler-runtime";
import clsx from "clsx";
import { HTMLAttributes } from "react";
import Image from "../internal/Image";
import { Locale } from "../lib/i18n";
interface PoweredByProps extends HTMLAttributes<HTMLDivElement> {
  locale?: Locale;
  className?: string;
}
const PoweredBy = t0 => {
  const $ = _c(13);
  let className;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      className,
      locale: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = t1;
  } else {
    className = $[1];
    props = $[2];
    t1 = $[3];
  }
  const locale = t1 === undefined ? "de" : t1;
  let t2;
  if ($[4] !== className) {
    t2 = clsx("flex justify-end items-center gap-2xs text-caption-1", className);
    $[4] = className;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const t3 = locale === "de" ? "Ein Service von" : "Powered by";
  let t4;
  if ($[6] !== t3) {
    t4 = <span>{t3}</span>;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Image className="h-3s w-auto mb-[2px]" src="https://cdn.justhome.com/cdn/assets/logo_43e3df0153.svg" alt="Ein Service von Justhome" width="170" height="40" />;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== props || $[10] !== t2 || $[11] !== t4) {
    t6 = <div {...props} className={t2}>{t4}{t5}</div>;
    $[9] = props;
    $[10] = t2;
    $[11] = t4;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
};
export default PoweredBy;